import { breakpoints } from "@brightagency/headstart-common";
import React from "react";
import styled from "styled-components";
import { TextButton, TextButtonGroup } from "../shared/TextButton";

const Outer = styled.div<{ hideUnderline?: boolean }>`
    &:not(:first-child) {
        padding-top: 16px;

        ${breakpoints.large} {
            padding-top: 24px;
        }
    }
`;

const Buttons = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const YesNo: React.FC<{
    question: string;
    onYes: () => void;
    onNo: () => void;
    value: boolean | undefined;
    hideUnderline?: boolean;
}> = props => {
    return (
        <Outer hideUnderline={props.hideUnderline}>
            <TextButtonGroup title={props.question}>
                <Buttons>
                    <TextButton isActive={props.value === true} onClick={props.onYes}>
                        Yes
                    </TextButton>
                    <TextButton isActive={props.value === false} onClick={props.onNo}>
                        No
                    </TextButton>
                </Buttons>
            </TextButtonGroup>
        </Outer>
    );
};
